import { Icon } from './Icon'

/**
 * Срок задачи одной строкой.
 *
 * Показывает не дату, а ответ на вопрос «когда за это браться»:
 * «Просрочено на 2 дня», «Сегодня до 18:00». Точная дата остаётся
 * в подсказке — она нужна, но реже, чем относительная.
 *
 * Формулировку и тон считает describeDue в домене: правило одно
 * на таблицу консоли, карточку водителя и календарь.
 */
export function DueBadge({ due, compact = false, withIcon = true }) {
  if (!due) return null

  return (
    <span
      className={`due-badge due-badge--${due.tone} ${compact ? 'due-badge--compact' : ''}`.trim()}
      title={due.exact}
    >
      {withIcon && (
        <Icon name={due.isOverdue ? 'warning' : 'clock'} size={compact ? 11 : 13} />
      )}
      {compact ? due.short : due.label}
    </span>
  )
}
